export default __webpack_public_path__ + "static/media/Group 2664.37958841.png";